import { AccordionContent } from '@radix-ui/react-accordion';
import { useTranslation } from 'next-i18next';
import { usePublicMetaFilter } from '@/module/public/hooks/usePublicMetaFilter';
import { FilterAccordionId } from '@/module/public/stores/AccordionStore';
import { MapTemplateTypeLocaleKey, MapTemplateTypes } from '@/types';
import { Button } from '@/ui_v3';
import { AccordionItem, AccordionTrigger } from '@/ui_v3/components/accordion';
export const TemplateTypeAccordion = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    handleSelectedMapTemplateType,
    selectedMapTemplate: _selectedMapTemplate
  } = usePublicMetaFilter();
  const selectedMapTemplate = _selectedMapTemplate || 'total';
  return <AccordionItem value={FilterAccordionId.TemplateType} data-sentry-element="AccordionItem" data-sentry-component="TemplateTypeAccordion" data-sentry-source-file="TemplateTypeAccordion.tsx">
      <AccordionTrigger data-sentry-element="AccordionTrigger" data-sentry-source-file="TemplateTypeAccordion.tsx">{t('common.quizMapType')}</AccordionTrigger>
      <AccordionContent data-sentry-element="AccordionContent" data-sentry-source-file="TemplateTypeAccordion.tsx">
        <div className={'flex w-full flex-row flex-wrap gap-xs p-md'}>
          {MapTemplateTypes.map(type => <Button size={'sm'} intent={selectedMapTemplate === type ? 'strong' : 'neutral'} onClick={() => {
          handleSelectedMapTemplateType(type === 'total' ? '' : type);
        }} variant="contained" key={type}>
              {t(MapTemplateTypeLocaleKey[type])}
            </Button>)}
        </div>
      </AccordionContent>
    </AccordionItem>;
};